module.exports = __webpack_public_path__ + "img/sync-off-gray.cfcd9761.svg";